import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Notification, BasicAuthLogout, HistoryListener } from '@phishtool/ui';
const Page = ({ children }) => (_jsxs(_Fragment, { children: [_jsx(HistoryListener, {}), _jsx(BasicAuthLogout, {}), _jsx(Notification, { position: 150 }), _jsx(Flex, Object.assign({ direction: "column", flex: 1 }, { children: children }))] }));
export default Page;
